import { render, staticRenderFns } from "./job-form-specs-pricing.vue?vue&type=template&id=82bbea82&scoped=true"
import script from "./job-form-specs-pricing.vue?vue&type=script&lang=js"
export * from "./job-form-specs-pricing.vue?vue&type=script&lang=js"
import style0 from "./job-form-specs-pricing.vue?vue&type=style&index=0&id=82bbea82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bbea82",
  null
  
)

export default component.exports